import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'abs-cards',
  template: `<ng-content></ng-content>`,
  styles: [`:host ::ng-deep .card-demo-section .flex-display{display:-webkit-box;display:-ms-flexbox;display:flex}:host ::ng-deep .card-demo-section .flex-display .card{min-height:225px;background-color:#fff;border:3px solid #f2f2f2;padding:25px;color:#191919;font-family:font-regular,Omnes-ATT-W02;font-size:1.6rem;margin-bottom:15px}:host ::ng-deep .card-demo-section .flex-display .card:focus,:host ::ng-deep .card-demo-section .flex-display .card:hover{border-color:#009fdb;outline-color:#009fdb}:host ::ng-deep .card-demo-section .flex-display .card.large{min-height:350px}`]
})
export class AbsCardsComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
